var _g, _circle, _g2, _circle2, _g3, _g4, _path, _g5, _g6, _g7, _g8, _g9, _g10, _path2, _path3, _path4, _path5, _g11, _path6, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTopicMagnifying = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 438,
    height: 257,
    viewBox: "0 0 438 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3585_74782)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 360.637,
    cy: 189.097,
    r: 14.4858,
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 360.637,
    cy: 189.097,
    r: 13.2293,
    stroke: "#8F8B8F",
    strokeWidth: 2.51298
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_3585_74782)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 233.675,
    cy: 13.8487,
    r: 9.84867,
    fill: "white"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.675,
    cy: 13.8487,
    r: 8.86381,
    stroke: "#8F8B8F",
    strokeWidth: 1.96973
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_3585_74782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.307 209.406L160.307 201.344L262.35 131.817L362.878 57.2597L404.903 66.8711L404.903 74.6376L202.658 220.923L160.307 209.406ZM83.222 136.762L83.222 129.813L115.514 106.783L217.605 137.09L268.651 149.972L320.514 163.739L320.514 171.944L288.218 194.752L83.222 136.762ZM68.9407 183.548L68.9407 175.972L170.569 105.837L270.996 29.8312L312.526 41.1194L312.526 48.8858L110.608 195.67L68.9407 183.548ZM153.118 86.0768L153.118 79.1281L185.564 59.0683L287.655 89.3761L338.701 102.257L390.596 113.469L390.596 121.235L358.14 143.971L153.118 86.0768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.949 209.633L158.949 210.059L159.515 210.212L201.867 221.729L202.758 221.972L203.571 221.384L252.813 185.767L287.413 195.555L288.294 195.804L289.115 195.224L321.411 172.417L321.871 172.092L321.871 171.717L321.871 163.512L321.871 163.082L321.298 162.93L294.296 155.762L322.922 135.057L357.336 144.774L358.212 145.022L359.032 144.448L391.488 121.712L391.953 121.386L391.953 121.008L391.953 113.242L391.953 112.782L391.317 112.645L362.511 106.421L405.815 75.0992L406.26 74.7777L406.26 74.4104L406.26 66.644L406.26 66.1925L405.64 66.0508L363.616 56.4394L362.724 56.2354L361.949 56.81L311.339 94.3457L288.45 88.5698L267.883 82.464L313.442 49.345L313.883 49.0243L313.883 48.6586L313.883 40.8922L313.883 40.4662L313.317 40.3125L271.788 29.0243L270.869 28.7746L270.054 29.391L219.074 67.9742L186.385 58.2696L185.576 58.0296L184.759 58.5348L152.313 78.5946L151.761 78.9358L151.761 79.3553L151.761 86.304L151.761 86.7241L152.314 86.8803L182.741 95.4723L169.657 105.375L153.001 116.869L116.335 105.984L115.445 105.72L114.611 106.314L82.3185 129.345L81.8648 129.668L81.8648 130.04L81.8648 136.989L81.8648 137.409L82.4175 137.565L111.21 145.71L68.059 175.489L67.5835 175.817L67.5835 176.2L67.5835 183.776L67.5835 184.191L68.1269 184.349L109.794 196.47L110.694 196.732L111.524 196.129L161.364 159.898L202.476 171.528L159.434 200.854L158.949 201.184L158.949 201.571L158.949 209.633ZM261.448 131.347L244.526 142.877L218.4 136.284L200.967 131.109L231.175 109.149L274.778 121.462L261.448 131.347Z",
    stroke: "#8F8B8F",
    strokeWidth: 2.27277
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_3585_74782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.816 201.237L362.872 55.1524L403.709 66.6695L202.652 212.754L161.816 201.237ZM84.0297 128.998L115.509 106.19L319.691 163.776L288.212 186.584L84.0297 128.998ZM70.1368 175.191L270.99 29.239L311.827 40.7561L110.771 186.841L70.1368 175.191ZM153.952 78.2176L185.558 55.4459L389.741 113.031L358.134 135.803L153.952 78.2176Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.9 200.778L159.68 201.665L161.013 202.041L201.849 213.558L202.746 213.811L203.568 213.214L252.618 177.575L287.408 187.387L288.304 187.64L289.126 187.044L320.604 164.237L321.83 163.349L320.494 162.972L286.075 153.265L322.516 126.788L357.331 136.606L358.223 136.858L359.044 136.266L390.651 113.495L391.885 112.606L390.544 112.228L355.974 102.478L404.624 67.1289L405.845 66.2419L404.512 65.8659L363.676 54.3489L362.778 54.0958L361.956 54.6929L312.907 90.3317L264.092 76.5644L312.742 41.2155L313.963 40.3285L312.63 39.9525L271.794 28.4355L270.896 28.1824L270.074 28.7796L221.028 64.4193L186.362 54.6423L185.47 54.3906L184.648 54.9824L153.042 77.7542L151.808 78.6431L153.149 79.0212L187.573 88.7299L151.135 115.208L116.312 105.387L115.416 105.134L114.595 105.73L83.1159 128.537L81.8907 129.425L83.2262 129.802L117.679 139.519L69.221 174.731L68.0064 175.614L69.3278 175.993L109.962 187.643L110.86 187.901L111.686 187.3L160.736 151.662L209.551 165.429L160.9 200.778ZM230.634 100.874L279.449 114.642L243.009 141.119L194.193 127.352L230.634 100.874Z",
    stroke: "#8F8B8F",
    strokeWidth: 2.27277
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_di_3585_74782)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 13.502,
    ry: 25.4127,
    transform: "matrix(-0.655599 -0.755109 -0.755109 0.655599 144.858 140.46)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.602 130.951C131.393 135.474 127.686 140.662 125.879 145.358C124.055 150.095 124.239 154.087 126.355 156.524C128.471 158.961 132.398 159.704 137.344 158.564C142.247 157.434 147.905 154.492 153.114 149.969C158.324 145.446 162.031 140.257 163.838 135.562C165.662 130.824 165.477 126.832 163.361 124.395C161.245 121.958 157.319 121.215 152.372 122.356C147.469 123.486 141.812 126.428 136.602 130.951Z",
    stroke: "#8F8B8F",
    strokeWidth: 1.81822
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_di_3585_74782)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 13.502,
    ry: 28.3287,
    transform: "matrix(0.395785 0.918343 0.918343 -0.395785 152.558 104.016)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.542 115.581C164.63 112.526 170.415 108.407 174.048 104.257C177.731 100.05 178.995 96.0803 177.739 93.1639C176.482 90.2476 172.727 88.4403 167.141 88.2287C161.629 88.02 154.662 89.3968 147.574 92.4515C140.486 95.5062 134.701 99.6251 131.068 103.775C127.385 107.982 126.121 111.952 127.377 114.868C128.634 117.785 132.389 119.592 137.975 119.804C143.487 120.012 150.454 118.636 157.542 115.581Z",
    stroke: "#8F8B8F",
    strokeWidth: 1.81822
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_di_3585_74782)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-1_3585_74782",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.507 190.426C155.12 191.441 147.582 180.992 145.671 167.088C145.04 162.495 145.101 158.099 145.734 154.235C143.723 148.402 149.199 140.377 158.66 134.684C158.078 133.989 157.51 133.272 156.957 132.532C146.261 139.15 135.535 140.773 132.201 135.994C128.595 130.825 135.003 120.125 146.513 112.095C146.801 111.894 147.09 111.696 147.378 111.503C143.772 94.9156 148.879 79.3671 160.736 74.185C175.025 67.94 193.706 79.1151 202.46 99.1453C211.214 119.175 206.727 140.476 192.438 146.721C190.768 147.45 189.039 147.942 187.272 148.21C184.115 151.418 179.796 154.419 174.697 156.718C173.589 157.218 172.48 157.669 171.377 158.07C171.816 159.777 172.17 161.564 172.424 163.411C174.335 177.316 169.895 189.41 162.507 190.426Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.507 190.426C155.12 191.441 147.582 180.992 145.671 167.088C145.04 162.495 145.101 158.099 145.734 154.235C143.723 148.402 149.199 140.377 158.66 134.684C158.078 133.989 157.51 133.272 156.957 132.532C146.261 139.15 135.535 140.773 132.201 135.994C128.595 130.825 135.003 120.125 146.513 112.095C146.801 111.894 147.09 111.696 147.378 111.503C143.772 94.9156 148.879 79.3671 160.736 74.185C175.025 67.94 193.706 79.1151 202.46 99.1453C211.214 119.175 206.727 140.476 192.438 146.721C190.768 147.45 189.039 147.942 187.272 148.21C184.115 151.418 179.796 154.419 174.697 156.718C173.589 157.218 172.48 157.669 171.377 158.07C171.816 159.777 172.17 161.564 172.424 163.411C174.335 177.316 169.895 189.41 162.507 190.426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.671 167.088L147.472 166.841L145.671 167.088ZM162.507 190.426L162.755 192.227L162.755 192.227L162.507 190.426ZM145.734 154.235L147.528 154.528L147.602 154.076L147.452 153.642L145.734 154.235ZM158.66 134.684L159.597 136.241L161.418 135.146L160.054 133.517L158.66 134.684ZM156.957 132.532L158.413 131.443L157.416 130.11L156.001 130.986L156.957 132.532ZM132.201 135.994L133.692 134.953L133.692 134.953L132.201 135.994ZM146.513 112.095L147.554 113.586L147.554 113.586L146.513 112.095ZM147.378 111.503L148.391 113.013L149.418 112.324L149.155 111.116L147.378 111.503ZM160.736 74.185L161.465 75.8511L160.736 74.185ZM202.46 99.1453L204.126 98.4171L202.46 99.1453ZM192.438 146.721L193.166 148.387L193.166 148.387L192.438 146.721ZM187.272 148.21L187 146.412L186.401 146.503L185.976 146.935L187.272 148.21ZM174.697 156.718L173.95 155.061L173.95 155.061L174.697 156.718ZM171.377 158.07L170.756 156.361L169.205 156.925L169.616 158.523L171.377 158.07ZM172.424 163.411L174.225 163.164L172.424 163.411ZM143.87 167.336C144.857 174.523 147.308 180.906 150.561 185.416C153.761 189.852 158.069 192.871 162.755 192.227L162.26 188.624C159.559 188.996 156.403 187.299 153.51 183.288C150.669 179.351 148.395 173.558 147.472 166.841L143.87 167.336ZM143.939 153.941C143.276 157.998 143.216 162.576 143.87 167.336L147.472 166.841C146.864 162.413 146.927 158.2 147.528 154.528L143.939 153.941ZM147.452 153.642C146.708 151.484 147.265 148.627 149.407 145.416C151.526 142.241 155.04 138.984 159.597 136.241L157.722 133.126C152.819 136.076 148.865 139.678 146.383 143.398C143.924 147.081 142.748 151.153 144.015 154.827L147.452 153.642ZM160.054 133.517C159.494 132.847 158.947 132.156 158.413 131.443L155.501 133.622C156.074 134.387 156.663 135.131 157.266 135.851L160.054 133.517ZM156.001 130.986C150.806 134.2 145.686 136.146 141.56 136.737C137.293 137.348 134.739 136.454 133.692 134.953L130.71 137.034C132.997 140.312 137.473 140.996 142.076 140.337C146.82 139.657 152.413 137.482 157.914 134.078L156.001 130.986ZM133.692 134.953C132.555 133.323 132.721 130.271 135.248 126.051C137.678 121.994 141.959 117.489 147.554 113.586L145.473 110.603C139.557 114.731 134.879 119.591 132.129 124.183C129.475 128.613 128.241 133.496 130.71 137.034L133.692 134.953ZM147.554 113.586C147.833 113.391 148.112 113.2 148.391 113.013L146.365 109.993C146.068 110.193 145.77 110.396 145.473 110.603L147.554 113.586ZM149.155 111.116C145.635 94.925 150.759 80.5299 161.465 75.8511L160.008 72.519C147 78.2043 141.909 94.9061 145.602 111.889L149.155 111.116ZM161.465 75.8511C167.93 73.0252 175.547 74.0688 182.74 78.3723C189.93 82.6735 196.551 90.1651 200.794 99.8734L204.126 98.4171C199.615 88.0953 192.518 79.9842 184.607 75.2516C176.7 70.5213 167.831 69.0999 160.008 72.519L161.465 75.8511ZM200.794 99.8734C205.037 109.582 206.038 119.529 204.311 127.728C202.583 135.93 198.176 142.229 191.71 145.055L193.166 148.387C200.989 144.968 205.97 137.494 207.869 128.477C209.77 119.457 208.637 108.739 204.126 98.4171L200.794 99.8734ZM191.71 145.055C190.189 145.719 188.613 146.168 187 146.412L187.544 150.008C189.465 149.717 191.348 149.182 193.166 148.387L191.71 145.055ZM185.976 146.935C182.994 149.965 178.868 152.843 173.95 155.061L175.445 158.376C180.724 155.995 185.236 152.872 188.568 149.485L185.976 146.935ZM173.95 155.061C172.883 155.542 171.816 155.976 170.756 156.361L171.999 159.779C173.144 159.362 174.295 158.894 175.445 158.376L173.95 155.061ZM174.225 163.164C173.961 161.247 173.595 159.392 173.138 157.617L169.616 158.523C170.038 160.161 170.378 161.88 170.622 163.659L174.225 163.164ZM162.755 192.227C167.441 191.583 170.774 187.513 172.659 182.378C174.575 177.159 175.213 170.351 174.225 163.164L170.622 163.659C171.545 170.376 170.918 176.568 169.246 181.125C167.541 185.768 164.961 188.253 162.26 188.624L162.755 192.227Z",
    fill: "#8F8B8F",
    mask: "url(#path-13-inside-1_3585_74782)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_di_3585_74782)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.2189,
    height: 55.7518,
    rx: 8.3246,
    transform: "matrix(-0.981551 0.191202 0.191202 0.981551 204.797 73.8629)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.718513,
    y: 1.06616,
    width: 24.4007,
    height: 53.9335,
    rx: 7.41549,
    transform: "matrix(-0.981551 0.191202 0.191202 0.981551 203.169 74.02)",
    stroke: "#8F8B8F",
    strokeWidth: 1.81822
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_di_3585_74782)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 28.2357,
    transform: "matrix(-0.522861 0.852418 0.852418 0.522861 161.204 68.59)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 27.3266,
    transform: "matrix(-0.522861 0.852418 0.852418 0.522861 161.204 68.59)",
    stroke: "#8F8B8F",
    strokeWidth: 1.81822
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_3585_74782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.356 82.0188C144.275 91.5476 155.177 96.0951 164.706 92.176C174.235 88.2569 178.782 77.3552 174.863 67.8264C170.944 58.2976 163.015 60.9779 153.486 64.897C143.958 68.8161 136.437 72.49 140.356 82.0188Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.197 81.673C144.925 90.7374 155.296 95.0634 164.36 91.3353C173.425 87.6071 177.751 77.2367 174.022 68.1722C173.089 65.9019 171.95 64.4406 170.682 63.5382C169.421 62.6403 167.957 62.2421 166.271 62.2278C162.825 62.1985 158.635 63.7622 153.832 65.7377C149.029 67.7133 144.952 69.5494 142.523 71.9948C141.335 73.1914 140.575 74.5046 140.31 76.03C140.044 77.5631 140.263 79.4026 141.197 81.673Z",
    stroke: "#8F8B8F",
    strokeWidth: 1.81822
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.715 80.509C151.495 79.5646 151.059 78.8083 150.58 78.3401C150.091 77.8635 149.66 77.768 149.369 77.8356C149.079 77.9032 148.734 78.179 148.506 78.8223C148.282 79.4542 148.224 80.3251 148.444 81.2695C148.663 82.2139 149.099 82.9702 149.579 83.4384C150.068 83.915 150.499 84.0105 150.789 83.9429C151.08 83.8753 151.425 83.5995 151.653 82.9562C151.877 82.3243 151.935 81.4534 151.715 80.509Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.81822
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M166.301 76.2271C166.09 75.3178 165.671 74.5912 165.211 74.1426C164.742 73.6856 164.335 73.5996 164.067 73.662C163.799 73.7244 163.471 73.9812 163.252 74.598C163.038 75.2035 162.982 76.0405 163.193 76.9498C163.405 77.859 163.824 78.5856 164.284 79.0342C164.752 79.4912 165.159 79.5772 165.428 79.5148C165.696 79.4524 166.023 79.1956 166.242 78.5788C166.457 77.9734 166.513 77.1363 166.301 76.2271Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.81822
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 43.3947L119.699 99.7594V129.703L0 184.306V43.3947Z",
    fill: "url(#paint0_linear_3585_74782)"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_i_3585_74782)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.73,
    cy: 115.366,
    rx: 16.667,
    ry: 15.9094,
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M138.14 115.366C138.14 123.404 131.296 130.019 122.73 130.019C114.163 130.019 107.319 123.404 107.319 115.366C107.319 107.328 114.163 100.713 122.73 100.713C131.296 100.713 138.14 107.328 138.14 115.366Z",
    stroke: "#8F8B8F",
    strokeWidth: 2.51298
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 176.006,
    y: 17.3911,
    width: 2.21934,
    height: 12.5763,
    rx: 1.10967,
    fill: "#8F8B8F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 170.827,
    y: 24.7881,
    width: 2.21934,
    height: 12.5763,
    rx: 1.10967,
    transform: "rotate(-90 170.827 24.7881)",
    fill: "#8F8B8F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 396.383,
    y: 142.38,
    width: 4.20127,
    height: 23.8072,
    rx: 2.10064,
    fill: "#8F8B8F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 386.579,
    y: 156.385,
    width: 4.20127,
    height: 23.8072,
    rx: 2.10064,
    transform: "rotate(-90 386.579 156.385)",
    fill: "#8F8B8F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 339.401,
    y: 22.1821,
    width: 38.9513,
    height: 3.76948,
    rx: 1.88474,
    fill: "#8F8B8F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 360.761,
    y: 32.9734,
    width: 38.9513,
    height: 3.76948,
    rx: 1.88474,
    fill: "#8F8B8F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3585_74782",
    x: 340.091,
    y: 174.611,
    width: 35.0324,
    height: 31.4847,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -6.06072,
    dy: 2.51298
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.81831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.995833 0 0 0 0 0.811438 0 0 0 0 0.157674 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3585_74782"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_3585_74782",
    x: 217.766,
    y: 4,
    width: 25.7581,
    height: 22.2104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -6.06072,
    dy: 2.51298
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.14123
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9125 0 0 0 0 0.29245 0 0 0 0 0.216719 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3585_74782"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_3585_74782",
    x: 35.9227,
    y: 0.444643,
    width: 401.998,
    height: 255.911,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.03036
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.1518
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3585_74782"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3585_74782",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.32984,
    dy: 1.66492
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.3246
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.597333 0 0 0 0 0.956863 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3585_74782"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_3585_74782",
    x: 65.8761,
    y: 27.1257,
    width: 349.681,
    height: 187.742,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7.5759
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.3639
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.560784 0 0 0 0 0.545098 0 0 0 0 0.560784 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3585_74782"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_di_3585_74782",
    x: 93.417,
    y: 96.6815,
    width: 102.883,
    height: 99.6779,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.06072
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.1518
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3585_74782"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3585_74782",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -6.06072,
    dy: -1.51518
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.09108
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.219608 0 0 0 0 0.854902 0 0 0 0 0.545098 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3585_74782"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_di_3585_74782",
    x: 95.6904,
    y: 63.0562,
    width: 113.735,
    height: 94.0414,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.06072
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.1518
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3585_74782"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3585_74782",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -6.06072,
    dy: -1.51518
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.09108
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.219608 0 0 0 0 0.854902 0 0 0 0 0.545098 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3585_74782"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_di_3585_74782",
    x: 100.893,
    y: 48.2101,
    width: 136.345,
    height: 178.648,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.06072
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.1518
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3585_74782"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3585_74782",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -6.06072,
    dy: -1.51518
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.3639
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.219608 0 0 0 0 0.854902 0 0 0 0 0.545098 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3585_74782"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_di_3585_74782",
    x: 150.194,
    y: 51.0565,
    width: 94.1291,
    height: 117.47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.06072
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.1518
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3585_74782"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3585_74782",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -6.06072,
    dy: -1.51518
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.06072
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.219608 0 0 0 0 0.854902 0 0 0 0 0.545098 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3585_74782"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_di_3585_74782",
    x: 102.66,
    y: 16.1075,
    width: 117.087,
    height: 117.087,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.06072
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.1518
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3585_74782"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3585_74782",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -6.06072,
    dy: 3.03036
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.3639
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.219608 0 0 0 0 0.854902 0 0 0 0 0.545098 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3585_74782"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_3585_74782",
    x: 139.296,
    y: 61.3182,
    width: 43.634,
    height: 33.9299,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.65968,
    dy: 1.66492
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.32984
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.623529 0 0 0 0 0.956863 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3585_74782"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_i_3585_74782",
    x: 100.002,
    y: 99.4564,
    width: 39.3947,
    height: 31.8188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -6.06072
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.30313
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.592157 0 0 0 0 0.278431 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3585_74782"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3585_74782",
    x1: 119.699,
    y1: 113.851,
    x2: -11.4418,
    y2: 113.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9747FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTopicMagnifying);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/topic-magnifying.e2900bf27c36d54a4fd3cce1abe86e32.svg";